import { render } from "./AddAnnouncementForm.vue?vue&type=template&id=21ad4d51"
import script from "./AddAnnouncementForm.vue?vue&type=script&lang=js"
export * from "./AddAnnouncementForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__